import type { Context } from 'react';
import { createContext } from 'react';

import type { SemanticHeadingBaseLevel } from './SemanticHeading.types';

const SemanticHeadingBaseLevelContext: Context<SemanticHeadingBaseLevel> = createContext<SemanticHeadingBaseLevel>(0);

export default SemanticHeadingBaseLevelContext;
